/**
 * Registry of all user filter keys used across the application.
 * These keys identify different data table preferences and filters stored via the user filters endpoint.
 */
export type UserFilterKey = (typeof UserFilterKeys)[keyof typeof UserFilterKeys]
export const UserFilterKeys = {
  /** Playground - Manage columns demo table */
  PlaygroundManageColumns: 'playground-manage-columns',

  /** Invoice finalized page - Items section table columns */
  InvoiceFinalizedItemsColumns: 'invoice-finalized-items-columns',

  /** Invoice finalized page - Payments section table columns */
  InvoiceFinalizedPaymentsColumns: 'invoice-finalized-payments-columns',

  /** Invoice finalized page - Insurance claims section table columns */
  InvoiceFinalizedInsuranceClaimsColumns:
    'invoice-finalized-insurance-claims-columns',

  /** Invoice finalized page - Credit applications section table columns */
  InvoiceFinalizedCreditApplicationsColumns:
    'invoice-finalized-credit-applications-columns',

  /** Invoice finalized page - Credit notes section table columns */
  InvoiceFinalizedCreditNotesColumns: 'invoice-finalized-credit-notes-columns',
} as const
